<template>
  <div class="container py-5">
    <div class="card shadow-sm">
      <div class="card-body">
        <div v-if="sessid !== 'LOGOUT'">
          <div v-if="!failed">
            <h3><i class="fa-solid fa-spinner"></i> Authentication in progress. Please wait...</h3>
          </div>
          <div v-else>
            <h3><i class="fa-solid fa-ban"></i> Invalid token.</h3>
          </div>
        </div>
        <div v-else>
          <h3><i class="fa-solid fa-hourglass-end"></i> Session has expired</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "./Source/user"; 
import CryptoJS from "crypto-js";
export default {
  props: {
    id: String,
  },
  data() {
    return {
      failed: false,
      sessid: window.location.href.split('/Session/')[1],
    };
  },
  watch: {
    id() {
      this.sessid = this.id;
    },
  },
  mounted() {
    this.failed = false;
    if (this.sessid && this.sessid !== "LOGOUT") {
      Api.Auth(this.sessid).then((response) => {
        if (response.data) {
          console.log(response.data)
          window.localStorage.setItem(
            "jwt",
            CryptoJS.AES.encrypt(
              JSON.stringify(response.data.jwt),
              "secret_key"
            ).toString()
          );
          window.localStorage.setItem(
            "user",
            CryptoJS.AES.encrypt(
              JSON.stringify(response.data.user),
              "secret_key"
            ).toString()
          );
          window.dispatchEvent(new CustomEvent("progress-auth-updated"));
          this.$router.push("/catalog");
        } else {
          this.failed = true;
        }
      });
    } else {
      this.failed = true;
    }
  },
};
</script>

<style lang="scss" scoped></style>